export interface VirtualPageSegment {
  pageNumber: string
  html: string
}

export function getBodyPageNumbers(html: string | null | undefined): string[] {
  if (!html) {
    return []
  }

  const patterns = [
    /\bid\s*=\s*\\?["']p(\d+)\\?["']/gi,
    /\bhref\s*=\s*\\?["'][^"'#>]*#p(\d+)\\?["']/gi,
  ]

  const matches: number[] = []

  for (const pattern of patterns) {
    for (const match of html.matchAll(pattern)) {
      const value = match[1]
      if (!value) {
        continue
      }

      const parsed = Number.parseInt(value, 10)
      if (Number.isFinite(parsed)) {
        matches.push(parsed)
      }
    }
  }

  const uniqueSortedNumbers = [...new Set(matches)].sort((a, b) => a - b)
  return uniqueSortedNumbers.map(String)
}

export function splitVirtualPageSegments(html: string): VirtualPageSegment[] {
  if (!html) {
    return []
  }

  const anchorPattern = /<a[^>]*\sid=\\?["']p(\d+)\\?["'][^>]*>/gi
  const anchors = Array.from(html.matchAll(anchorPattern))
    .map(match => ({
      index: match.index,
      pageNumber: match[1],
    }))
    .filter((anchor): anchor is { index: number, pageNumber: string } => typeof anchor.index === 'number' && !!anchor.pageNumber)

  if (anchors.length <= 1) {
    return []
  }

  const segments: VirtualPageSegment[] = []

  for (let i = 0; i < anchors.length; i += 1) {
    const current = anchors[i]
    if (!current) {
      continue
    }

    const next = anchors[i + 1]
    const start = current.index
    const end = next?.index ?? html.length
    const content = html.slice(start, end).trim()

    if (!content) {
      continue
    }

    segments.push({
      pageNumber: current.pageNumber,
      html: content,
    })
  }

  return segments
}
